import React from 'react';
import styled from '@emotion/styled';

const StyledTexthtmlEditorModule = styled.div``;

function TexthtmlEditorModule({ props: { content } }) {
	return (
		<StyledTexthtmlEditorModule>
			<div className='container'>
				{content ? (
					<div
						dangerouslySetInnerHTML={{
							__html: content,
						}}
					></div>
				) : null}
			</div>
		</StyledTexthtmlEditorModule>
	);
}

export default TexthtmlEditorModule;
